<template>
  <div class="view">
    <div class="condition">
      <div class="check_wrap">
        <!--          (0全部、1企业公众号、2企业自定义添加、3企业员工提供)-->
        <el-radio-group v-model="listForm.type" @change="radioChange" size="small">
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="1">企业公众号</el-radio-button>
          <el-radio-button label="2">企业自定义添加</el-radio-button>
          <el-radio-button label="3">企业员工提供</el-radio-button>
        </el-radio-group>
      </div>
      <div class="search_wrap">
        <el-form :inline="true" :model="listForm" class="form-inline">
          <el-form-item>
            <el-select clearable v-model="listForm.status" placeholder="发布状态" size="small">
              <el-option
                      v-for="(item,index) in articleStatus"
                      :value="item.value"
                      :label="item.label"
                      :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="listForm.name" placeholder="请输入文章标题" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchFn" size="small"></el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="other_wrap">
        <el-button type="primary" @click="goarticlecreate('add')" size="small">自定义添加</el-button>
      </div>
      <p class="materialword mb-10 mt20">1、发布后文章即可在APP企业文库里显示</p>
    </div>
    <div class="table_wrap">
      <el-table :data="articleList" style="width: 100%">
        <el-table-column prop="title" label="文章标题" width="260"></el-table-column>
        <el-table-column label="来源">
          <template slot-scope="scope">
            {{scope.row.source?scope.row.source:'暂无数据'}}
          </template>
        </el-table-column>
        <el-table-column prop="source_detail" label="内容来源"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <!--              "state":"状态(0待发布、1已发布)",-->
            <span v-if="scope.row.state==0">待发布</span>
            <span v-if="scope.row.state==1">已发布</span>
            <span v-if="scope.row.state==2">已下架</span>
          </template>
        </el-table-column>
        <el-table-column prop="release_time" label="发布时间"></el-table-column>
        <el-table-column prop="share_num" label="分享次数"></el-table-column>
        <el-table-column prop="customer_num" label="获客数"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="releaseFn(scope.row.id,scope.row.state)">
              <span v-if="scope.row.state==0||scope.row.state==2">发布</span>
              <span v-if="scope.row.state==1">下架</span>
            </el-button>
            <el-button type="text" size="small" @click="goarticlecreate('edit',scope.row.id)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
                background layout="prev, pager, next"
                :page-size="page.pagesize"
                :current-page="page.pageindex"
                :total="page.total"
                @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import {yeartime} from '@/assets/js/common'
  import {pagination} from "@/util/util.js";

  export default {
    name: "MaterialArticle",
    data() {
      return {
        articleStatus: [{
          value: 0,
          label: '全部'
        }, {
          value: 1,
          label: '已发布'
        }, {
          value: 2,
          label: '待发布'
        }, {
          value: 3,
          label: '已下架'
        }],
        listForm: {
          name: '',
          type: 0,
          status: 0
        },
        articleList: [],
        allpage: 0,
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        }
      };
    },
    created() {
      const loading = this.$loading({
        lock: true,
        text: '加载中…',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
      });
      this.InitFn(loading)
    },
    methods: {
      InitFn(loading) {
        // 创建执行
        this.listForm.page = this.page.pageindex
        this.axios
            .post('companyadmin/article', this.listForm)
            .then(response => {
              if (response.data.code == 0) {
                for (let i in response.data.list) {
                  response.data.list[i].release_time = yeartime(response.data.list[i].release_time)
                }
                this.articleList = response.data.list
                this.page.total = response.data.all_page
                loading.close();
              } else {
              }
            })
            .catch(response => {
            });
      },
      radioChange(option) {
        // 选择radio
        this.listForm.type = option
        this.page.total = 1
        this.InitFn()
      },
      handleCurrentChange(val) {
        const loading = this.$loading({
          lock: true,
          text: '加载中…',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.page.pageindex = val;
        this.InitFn(loading);
      },
      goarticlecreate(type, id) {
        if (type === 'add') {
          this.$router.push({name: "articleCreate", query: {type: type}});
        } else {
          if(sessionStorage.getItem("menu1")){
            this.$router.push({name: "articleCreate", params: {id: id, type: type}});
          }else{
            this.$router.push({path: "articleCreate", query: {id: id, type: type}});
          }  
        }
      },
      searchFn() {
        if (this.listForm.name === '') {
          this.$message({
            message: '请填写搜索的文章标题',
            type: 'warning'
          });
          return false
        }
        this.InitFn()
      },
      releaseFn(id, state) {
        const loading = this.$loading({
          lock: true,
          text: '设置中…',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        //  "state":"状态(0待发布、1已发布, 2 已下架)
        let url_ = 'companyadmin/article/release'
        if (state === 1) {
          url_ = 'companyadmin/article/down_shelves'
        }
        // 创建执行
        this.axios
            .post(url_, {article_id: id})
            .then(response => {
              if (response.data.code == 0) {
                this.InitFn(loading)
              } else {
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>
